import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';
import { IAreas } from '../Interfaces/IAreas';

@Injectable({
	providedIn: 'root',
})
export class AreasService extends RestCallService {
  public dataToSend: IAreas = {
    pkarea: 0,
    fksite: 0,
    sitename: '',
    area: '',
    requirednda: false,
    available: false,
    creationdate: new Date,
    strcreationdate: '',
    fkemployeecreator: 0,
    lastupdated: new Date,
    strlastupdated: '',
    fkemployeeupdater: 0,
    employeecreatorname: '',
    employeeupdatername: '',
    username: '',
    buildings_array: [],
    building_name: '',
    fk_building: 0,
    };

  constructor(
    public httpClient: HttpClient,
    private cognitoService: CognitoService,
    public toastr: ToastrService,
    public notificationService: NotificationService,
    public translate: TranslateApplicationService,
  ) {     
          super(httpClient, 'JACSapi', toastr, notificationService, translate);
  }
  
  public GetAvailableAreas() {
    if (!this.cognitoService.IsAuhtenticated()) {
      this.cognitoService.LogOut();
     }
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<IAreas[]>('/api/Areas/GetAvailableAreas', this.dataToSend);
  }

  public GetAreasByBuilding(data:any) {
    if (!this.cognitoService.IsAuhtenticated()) {
      this.cognitoService.LogOut();
    }
    this.dataToSend.fk_building = data;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<IAreas[]>('/api/Areas/GetAreasByBuilding', this.dataToSend);
  }

  public GetList() {
    if (!this.cognitoService.IsAuhtenticated())
        this.cognitoService.LogOut();
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<IAreas[]>('/api/Areas/GetAreas', this.dataToSend);
  }

  public GetAreasWithBuildings() {
    if (!this.cognitoService.IsAuhtenticated())
        this.cognitoService.LogOut();
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<IAreas[]>('/api/Areas/GetAreasAndBuildings', this.dataToSend);
  }

  public CreateArea(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
        this.cognitoService.LogOut();
    this.dataToSend.area = data.txtarea;
    this.dataToSend.requirednda = data.chkrequirednda;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<IAreas>('/api/Areas/CreateArea', this.dataToSend);
  }
    
  public UpdateArea(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
        this.cognitoService.LogOut();
    this.dataToSend.pkarea = data.pkarea;
    this.dataToSend.area = data.txtarea;
    this.dataToSend.requirednda = data.chkrequirednda;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.put('/api/Areas/UpdateArea', this.dataToSend);
  }
  public ChangeStatusArea(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
        this.cognitoService.LogOut();
    this.dataToSend.pkarea = data.pkarea;
    this.dataToSend.available = data.available;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.put('/api/Areas/ChangeStatusArea', this.dataToSend);
  }
  public ChangeStatusRequiredNDA(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
            this.cognitoService.LogOut();
    this.dataToSend.pkarea = data.pkarea;
    this.dataToSend.requirednda = data.requirednda;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.put('/api/Areas/ChangeStatusRequiredNDA', this.dataToSend);
  } 


  public ExistsGlobalNDA(){
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    this.dataToSend.username = localStorage.getItem('username');
    return this.post('/api/Areas/ExistsGlobalNDA', this.dataToSend);
  }

  public CreateAreaBuilding(data: any)
  {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.pkarea = data.pkarea;
    this.dataToSend.buildings_array = data.cbbuildings;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post('/api/Areas/SetAreaByBuildings', this.dataToSend);
  }

  public UpdateAreaBuilding(data: any)
  {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.pkarea = data.pkarea;
    this.dataToSend.buildings_array = data.cbbuildings;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post('/api/Areas/UpdateAreaByBuildings', this.dataToSend);
  }
}
